import { useTheme } from "@mui/material";
import type { FC } from "react";
import { CALCULATOR_CATALOG } from "web_myplann/Calculators/Utils/calculatorCatalog";
import { getCalculatorAreaColor } from "web_myplann/Calculators/Utils/getCalculatorAreaColor";
import { QuickCalculatorTile } from "web_myplann/Dashboard/Components/QuickCalculatorTile";
import type { QuickCalculatorItem } from "web_myplann/Dashboard/Types/QuickCalculator";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	calculator: QuickCalculatorItem;
	onClick: () => void;
};

export const QuickCalculatorProductTile: FC<Props> = ({
	calculator,
	onClick,
}) => {
	const { dashboard, palette } = useTheme();
	const { t } = useResource();
	const { area, icon: Icon } = CALCULATOR_CATALOG[calculator.type];
	const { tint, ink } = getCalculatorAreaColor(palette, area);

	return (
		<QuickCalculatorTile
			label={t(Resources.Dashboard.QuickCalculators.Items[calculator.type])}
			iconBg={calculator.isLocked ? palette.grey[200] : tint}
			icon={
				<Icon
					aria-hidden
					size={dashboard.quickCalculator.tile.iconSize}
					color={calculator.isLocked ? palette.grey[500] : ink}
				/>
			}
			isLocked={calculator.isLocked}
			onClick={onClick}
		/>
	);
};
